export const isSubdomain = () => {
  const host = window.location.hostname;

  // localhost handling
  if (host.includes('localhost')) {
    return host.split('.').length > 1;
  }

  // production
  return host.split('.').length > 2;
};
